export const CHAT_PENDING_TIMEOUT_MS = 10000;
